import { createClientRouteContext } from './create-client-route-context';

import type { BaseRoute, ClientRouteContextValue } from '../types';

export function createInjectedRouteContext(
  routes: BaseRoute[],
  activeRoute: string
): ClientRouteContextValue {
  return createClientRouteContext(
    routes.map(route => {
      if (route.url !== activeRoute) {
        return {
          id: route.id,
          url: route.url,
          title: route.title,
          document: undefined,
        };
      }

      return route;
    })
  );
}
